import { isUndNullEmp } from '../../helpers/main.js';

export class UserCompany {
    constructor(
        _id = 0,
        _userId = '',
        _companyId = 0,
        _register = '',
    ) {
        this.id = _id;
        this.userId = _userId;
        this.companyId = _companyId;
        this.register = _register;
    }

    static getClassName = () => {
        return 'UserCompany - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 1,
                    UserId: 10,
                    CompanyId: 1,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    UserId: 450,
                    CompanyId: 450,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 1,
                    userId: 10,
                    companyId: 1,
                    register: 10,
                },
                max: {
                    id: 450,
                    userId: 450,
                    companyId: 450,
                    register: 30,
                },
            };
        }
    }

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: UserCompany.getClassName() })?.result) {
            if (upperCase) {
                return new UserCompany(
                    obj.Id,
                    obj.UserId,
                    obj.CompanyId,
                    obj.Register,
                );
            } else {
                return new UserCompany(
                    obj.id,
                    obj.userId,
                    obj.companyId,
                    obj.register,
                );
            }
        } else {
            return new UserCompany();
        }
    }
}